import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Tooltip, Typography, styled } from '@mui/material';
import { cloneElement, forwardRef } from 'react';
import { isReactElement } from '../helpers/is-react-element';
const ChartKPIRootCompact = styled(Box)(({ theme, severity }) => ({
    color: theme.palette[severity || 'info'].main,
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
    '& .chart-kpi-icon': {
        color: 'inherit',
        fontSize: 'inherit',
    },
}));
const ChartKPIRootCompactIcon = styled(Box)(({ theme }) => ({
    fontSize: '1.5rem',
}));
const ChartKPIRootDescriptive = styled(Box)(({ theme, severity }) => ({
    color: theme.palette[severity || 'info'].main,
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
}));
const ChartKPIRootDescriptiveIcon = styled(Box)(({ theme }) => ({
    fontSize: '2rem',
    display: 'flex',
    alignItems: 'center',
    maxHeight: theme.spacing(4),
}));
const ChartKPICompactValue = styled(Box)(({ theme }) => {
    return {
        gap: theme.spacing(0.5),
        display: 'flex',
        alignItems: 'center',
    };
});
const ChartKPIDescriptiveContainer = styled(Box)(({ theme }) => ({
    gap: theme.spacing(1),
    display: 'flex',
}));
const ChartKPIDescriptiveContainerDescription = styled(Box)(({ theme }) => ({
    display: 'flex',
    flex: '1',
    alignItems: 'center',
}));
export const ChartKPI = forwardRef(({ icon, label, description, value = '-', variant = 'compact', tooltip, ...boxProps }, ref) => {
    // ensure icon is a react element and if so clone it to add
    // styles in order to inherit color and font size
    const _icon = isReactElement(icon)
        ? cloneElement(icon, { style: { fontSize: 'inherit', color: 'inherit' } })
        : icon;
    let element;
    switch (variant) {
        case 'compact':
            element = (_jsx(ChartKPIRootCompact, { ...boxProps, ref: ref, children: _jsxs(Box, { children: [_jsxs(ChartKPICompactValue, { children: [_icon && _jsx(ChartKPIRootCompactIcon, { color: "inherit", children: _icon }), _jsx(Typography, { component: 'h3', variant: 'h2', color: "inherit", children: value })] }), _jsx(Typography, { marginTop: 0.5, fontWeight: 500, variant: "h6", children: label })] }) }));
            break;
        case 'descriptive':
            element = (_jsx(ChartKPIRootDescriptive, { ...boxProps, ref: ref, children: _jsxs(ChartKPIDescriptiveContainer, { children: [_icon && _jsx(ChartKPIRootDescriptiveIcon, { color: "inherit", children: _icon }), _jsx(ChartKPIDescriptiveContainerDescription, { children: _jsx(Typography, { variant: "body2", children: description }) }), _jsxs(Box, { flexGrow: "0", children: [_jsx(Typography, { component: 'h3', variant: 'h1', fontWeight: 500, color: "inherit", children: value }), _jsx(Typography, { variant: "h6", children: label })] })] }) }));
            break;
        default:
            element = _jsx(_Fragment, { children: "Not implemented yet" });
            break;
    }
    if (tooltip) {
        return _jsx(Tooltip, { title: tooltip, children: element });
    }
    return element;
});
